import React from 'react';
import FlowMessage from './FlowMessage.tsx';
import TextMessage from './TextMessage.tsx';
import MessageDefault from './MessageDefault.tsx';
import MessageAudio from './MessageAudio.tsx';
import MessageButtonQuickReply from './MessageButtonQuickReply.tsx';
import MessageCatalog from './MessageCatalog.tsx';
import MessageFile from './MessageFile.tsx';
import MessageImage from './MessageImage.tsx';
import MessageList from './MessageList.tsx';
import MessageLocation from './MessageLocation.tsx';
import MessageNfmReply from './MessageNfmReply.tsx';
import MessageOrder from './MessageOrder.tsx';
import MessagePayment from './MessagePayment.tsx';
import MessageTypeButtonReply from './MessageTypeButtonReply.tsx';
import MessageVideo from './MessageVideo.tsx';
import Message from './Message.tsx';
import MessageButtons from './MessageButtons.tsx';
import MessageAddress from './MessageAddress.tsx';
import OrderStatusMessage from './OrderStatusMessage.tsx';
import MessageInterventionReply from './MessageInterventionReply.tsx';
import OpenAIMessage from './OpenAIMessage.tsx';
import CTAURLMessage from './CTAURLMessage.tsx';
import MessageTemplate from './MessageTemplate.tsx';

interface MessageProps {
  message: any;
  onButtonClick?: (button: any) => void;
  onListItemClick?: (option: any) => void;
}

const MessageNode: React.FC<MessageProps> = ({ message, onButtonClick, onListItemClick }) => {
  const type = message?.content?.type;
  const origin = message?.origin;

  switch (type) {
    case 'text':
    case 'flow':
    case 'order_details':
    case 'list_reply':
    case 'address': 
      return <Message message={message} />;
    case 'TEXT':
      return <TextMessage message={message} />;
    case 'button_reply':
      return <MessageTypeButtonReply message={message} />;
    case 'file':
    case 'DOCUMENT':
    case 'document':
      return <MessageFile message={message} />;
    case 'INTERVENTION':
      return <MessageInterventionReply message={message} />
    case 'BUTTONS':
      return <MessageButtons message={message} onButtonClick={onButtonClick} />;
    case 'image':
    case 'IMAGE':
      return <MessageImage message={message} />;
    case 'ADDRESS':
      return <MessageAddress message={message} />;
    case 'Flow':
      return <FlowMessage message={message} />;
    case 'OPENAI':
      return <OpenAIMessage message={message} />;
    case 'list':
    case 'LIST':
      return <MessageList message={message} onListItemClick={onListItemClick} />;
    case 'VIDEO':
    case 'video':
      return <MessageVideo message={message} />;
    case 'AUDIO':
    case 'audio':
      return <MessageAudio message={message} />;
    case 'quick_reply':
      return <MessageButtonQuickReply message={message} />;
    case 'nfm_reply':
      return <MessageNfmReply message={message} />;
    case 'order':
    case 'ORDER':
    case 'ORDERDETAILS':
      return <MessageOrder message={message} />;
    case 'ORDERSTATUS':
      return <OrderStatusMessage message={message} />;
    case 'catalog_message':
    case 'catelog':
    case 'CATALOG':
      return <MessageCatalog message={message} />;
    case 'location':
      return <MessageLocation message={message} />;
    case 'payment':
      return <MessagePayment message={message} />;
    case 'CTAURL': 
      return <CTAURLMessage content={message?.content} />;
    case 'TEMPLATE': 
      return <MessageTemplate content={message.content} />
     
    case 'template':                        
      return <MessageTemplate message={message} onButtonClick={onButtonClick} />;
    default:
      return <MessageDefault message={message} />;
  }
};

export default MessageNode;
